import styled from "styled-components";

import { color, breakpoints } from "style/constants";
import { Link } from "react-router-dom";

export const StyledP = styled.p`
  color: ${color.DARKERGRAY};
  font-size: 12px;
  margin: 0;
`;

export const PrivacyPolicyLink = styled(Link)`
  color: ${color.DARKERGRAY};
  font-size: 12px;
  line-height: 1.5rem;
  text-decoration: none;
  display: inline-block;
  margin-left: 16px;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${breakpoints.lg}px) {
    text-align: center;
    display: block;
  }
`;
